import clsx from "clsx";
import {
	AlertTriangle,
	ArrowLeft,
	ArrowRight,
	Award,
	BarChart3,
	BookOpen,
	Calendar,
	Camera,
	Check,
	ClipboardCheck,
	ClipboardList,
	Download,
	Eye,
	EyeOff,
	FileBarChart,
	FileText,
	Grid,
	Home,
	Landmark,
	Layers,
	LayoutDashboard,
	ListChecks,
	Lock,
	LogOut,
	Map,
	Menu,
	MessageSquareWarning,
	Minus,
	MoreHorizontal,
	Pencil,
	Play,
	Plus,
	Search,
	Settings,
	SquareArrowRight,
	Trash2,
	UserCircle,
	UserPlus,
	Users,
	Video,
	X,
} from "lucide-react";
import type React from "react";
import { getLayout } from "../../layout/core";
import icons from "../icons-config/icons";

type Props = {
	className?: string;
	iconType?: "duotone" | "solid" | "outline";
	iconName: string;
	activeColor?: string; // optional custom active color
	isActive?: boolean;
};

const LucideIconMap: Record<string, any> = {
	"element-11": LayoutDashboard,
	"profile-user": UserPlus,
	"setting-2": Settings,
	"book-open": BookOpen,
	"calendar-8": Calendar,
	"chart-line-star": FileBarChart,
	"profile-circle": UserCircle,
	"chart-simple": BarChart3,
	"abstract-26": AlertTriangle,
	"information-5": AlertTriangle,
	information: AlertTriangle,
	minus: Minus,
	lock: Lock,
	"exit-right": LogOut,
	"exit-left": ArrowLeft,
	"entrance-left": ArrowRight,
	"entrance-right": ArrowLeft, // Sometimes used for toggle
	"abstract-14": Menu,
	magnifier: Search,
	cross: X,
	"cross-circle": X,
	check: Check,
	"check-circle": Check,
	"dots-horizontal": MoreHorizontal,
	"arrow-right": ArrowRight,
	"arrow-left": ArrowLeft,
	plus: Plus,
	trash: Trash2,
	pencil: Pencil,
	eye: Eye,
	"eye-slash": EyeOff,
	download: Download,
	complaint: MessageSquareWarning,
	"square-arrow-right": SquareArrowRight,
	map: Map,
	grid: Grid,
	home: Home,
	people: Users,
	scheme: FileText,
	layers: Layers,
	"calendar-tick": ClipboardCheck,
	"medal-star": Award,
	play: Play,
	landmark: Landmark,
	camera: Camera,
	video: Video,
	"clipboard-list": ClipboardList,
	"list-checks": ListChecks,
};

const KTIcon: React.FC<Props> = ({
	className = "",
	iconType,
	iconName,
	activeColor = "text-danger", // bootstrap / theme color
	isActive = false,
}) => {
	const LucideIcon = LucideIconMap[iconName];

	if (LucideIcon) {
		return (
			<span className={clsx("", className)}>
				<LucideIcon size="1em" strokeWidth={2} />
			</span>
		);
	}

	if (!iconType) {
		iconType = getLayout().main?.iconType;
	}

	return (
		<i
			className={clsx(`ki-${iconType} ki-${iconName}`, className, {
				[`kt-icon-active ${activeColor}`]: isActive,
			})}
		>
			{iconType === "duotone" &&
				[...Array(icons[iconName])].map((_e, i) => {
					return (
						<span
							key={`${iconType}-${iconName}-${className}-path-${i + 1}`}
							className={`path${i + 1}`}
						></span>
					);
				})}
		</i>
	);
};

export { KTIcon };
